import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'V.T.',
  role: 'Ballet Teacher | New York, USA',
  text: 'The barre work system completely changed how I structure my classes. The sequences are already written—I just teach them. My classes feel more professional than ever and my students are developing real technique.'
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'Ballet Instructor | Melbourne, Australia',
  text: 'The emergency lesson plans saved me more times than I can count in my first month. I used to panic when my original plan fell apart. Now I just open the library and teach.'
}, {
  initials: 'DG',
  name: 'D.G.',
  role: 'Ballet Teacher | Toronto, Canada',
  text: 'I review the cueing library before every session and walk in knowing exactly what I am going to say. The corrections are professional, clear, and my students actually understand what I am asking them to do.'
}, {
  initials: 'AM',
  name: 'A.M.',
  role: 'Ballet Instructor | London, United Kingdom',
  text: 'The pre-ballet activities gave me complete confidence with my 3 to 6 year old classes. Before this I was always searching for ideas. Now I have 50 activities ready to go—and the children absolutely love them.'
}, {
  initials: 'SR',
  name: 'S.R.',
  role: 'Ballet Teacher | Dublin, Ireland',
  text: 'The recital planner was a revelation. My last recital was the most organized I have ever run. No forgotten details, no last-minute panic—everything was under control from the first rehearsal to the final curtain.'
}];
export function ExtendedTestimonials() {
  return <section className="border-y border-ballet-line bg-white px-4 py-20 sm:py-28" data-id="element-68" data-mp="3hpfu4813rcn0">
      <div className="mx-auto max-w-6xl" data-id="element-69" data-mp="2bb6rf6i7cg3j">
        <div className="text-center" data-id="element-70" data-mp="2b82gzre58o4f">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-ballet-rose" data-id="element-71" data-mp="26aj2cqdja9by">
            Teacher stories
          </p>
          <h2 className="mt-3 font-display text-5xl font-semibold text-ballet-ink" data-id="element-72" data-mp="27tizzd137lvj">
            What ballet teachers who already have their library are saying
          </h2>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-73" data-mp="1yqhyxqr2wkyq">
          {testimonials.map((testimonial, index) => <motion.figure key={testimonial.initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className={`relative rounded-2xl border border-ballet-line bg-ballet-canvas p-7 shadow-card ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-74" data-mp="23ot962lacxhh" data-mpi={index}>
              <QuoteIcon size={42} className="absolute right-6 top-5 text-ballet-pink/50" data-id="element-75" data-mp="1b1fi2l49qw5a" />
              <div className="flex gap-1 text-ballet-gold" data-id="element-76" data-mp="mh3qsw7mcwxi">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} size={15} fill="currentColor" data-id="element-77" data-mp="wf9pz621joyo" />)}
              </div>
              <blockquote className="mt-5 text-sm leading-6 text-ballet-muted" data-id="element-78" data-mp="1ae9fsh1ai9wf">
                “{testimonial.text}”
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3" data-id="element-79" data-mp="15fogcjtv3u91">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ballet-blush text-sm font-bold text-ballet-rose" data-id="element-80" data-mp="1k3sztq0qo9sv">
                  {testimonial.initials}
                </span>
                <span data-id="element-81" data-mp="1t6bzy2d548bf">
                  <strong className="block text-sm text-ballet-ink" data-id="element-82" data-mp="1t5skcsaypw0k">
                    {testimonial.name}
                  </strong>
                  <span className="block text-xs text-ballet-muted" data-id="element-83" data-mp="3imxr005ddysp">
                    {testimonial.role}
                  </span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}